import { Injectable } from '@angular/core';
import {Store} from "@ngrx/store";
import * as componentActions from "@catdetails/actions/avod";

@Injectable()
export class ProjectAvodService {

  constructor(private store: Store<any>) { }

  setActive() {
    this.store.dispatch({type: componentActions.PROJECT_AVOD_ACTIVATE});
  }

  setInActive() {
    this.store.dispatch({type: componentActions.PROJECT_AVOD_DEACTIVATE});
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-avod/services/project-avod.service.ts